module.exports = __webpack_public_path__ + "static/media/mazda-header-logo.69f635bb.svg";